<script setup>
import {
  ChipIcon,
  ChartBarIcon,
  UserGroupIcon,
  CollectionIcon,
  ReceiptRefundIcon,
  HomeIcon
} from '@heroicons/vue/outline'
import { Link } from '@inertiajs/inertia-vue3'
import { useStore } from '@admin_js/store'
import { useBreadStore } from '@bread/js/store'

const store = useStore()
const breadStore = useBreadStore()

const navigation = [
  {
    name: 'Dashboard',
    resource: 'dashboard',
    route: 'admin.dashboard.index',
    icon: HomeIcon,
    current: true,
    admin_only: false,
  },
  {
    name: 'Apparaten',
    resource: 'device',
    route: 'admin.devices.index',
    icon: ChipIcon,
    current: false,
    admin_only: false,
  },
  {
    name: 'Producten',
    resource: 'product',
    route: 'admin.products.index',
    icon: CollectionIcon,
    current: false,
    admin_only: false,
  },
  {
    name: 'Leeggoed',
    resource: 'retour',
    route: 'admin.retours.index',
    icon: ReceiptRefundIcon,
    current: false,
    admin_only: false,
  },
  {
    name: 'Grafieken',
    resource: 'graph',
    route: 'admin.graphs.show',
    icon: ChartBarIcon,
    current: false,
    admin_only: false,
  },
  {
    name: 'Gebruikers',
    resource: 'user',
    route: 'admin.users.index',
    icon: UserGroupIcon,
    current: false,
    admin_only: true,
  },
]

const setActive = (name) => {
  navigation.forEach((item) => (item.current = item.name === name))
}

const getMenuItemsForUser = () => {
  if (store.user && store.user.is_admin) {
    return navigation
  } else {
    return navigation.filter((item) => !item.admin_only)
  }
}
</script>

<style scoped></style>
<template>
  <nav class="mt-5 flex-1" aria-label="Sidebar">
    <div class="space-y-1 px-2">
      <Link
        @click="setActive(item.name)"
        v-for="item in getMenuItemsForUser()"
        :key="item.name"
        :href="route(item.route)"
        :class="[
          breadStore.isCurrent(item.resource)
            ? 'bg-gray-200 text-gray-900'
            : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900',
          'group flex items-center rounded-md px-2 py-2 text-sm font-medium',
        ]"
      >
        <component
          :is="item.icon"
          :class="[
            item.resource === store.resource
              ? 'text-gray-500'
              : 'text-gray-400 group-hover:text-gray-500',
            'mr-3 h-6 w-6',
          ]"
          aria-hidden="true"
        />
        {{ item.name }}
      </Link>
    </div>
  </nav>
</template>
